import script from "./PhotoGallery.vue?vue&type=script&setup=true&lang=ts"
export * from "./PhotoGallery.vue?vue&type=script&setup=true&lang=ts"

import "./PhotoGallery.vue?vue&type=style&index=0&id=0414d537&scoped=true&lang=scss"

import exportComponent from "/Users/jansavli/Documents/Socutno Zobozdravstvo/socutno-webpage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0414d537"]])

export default __exports__